import { render, staticRenderFns } from "./writeOff.vue?vue&type=template&id=67ad72c0&scoped=true"
import script from "./writeOff.vue?vue&type=script&lang=js"
export * from "./writeOff.vue?vue&type=script&lang=js"
import style0 from "./writeOff.vue?vue&type=style&index=0&id=67ad72c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad72c0",
  null
  
)

export default component.exports